import { css } from "styled-components";
import { FontMixin } from "../../../../../../../../../styles/common/mixins/helpers.styled.js";
const partnershipsPortaventuraPricesDesktopStyles = {
    PriceTopDesktop: ()=>css`
		color: ${({ theme  })=>theme.colors.grays.darker};
		text-transform: lowercase;
	`,
    PriceCurrentDesktop: ()=>css`
		font-family: ${({ theme  })=>theme.font.family.secondary};
		${FontMixin({
            weight: 'bold'
        })}
		color: ${({ theme  })=>theme.colors.grays.darker};
	`
};
export default partnershipsPortaventuraPricesDesktopStyles;

//# sourceMappingURL=portaventura.js.map